/**
 * Edit sub unit of form block.
 * @module components/manage/Blocks/OUNumbers/Item
 */

import React, { Component } from 'react';
import { Map } from 'immutable';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import Editor from 'draft-js-plugins-editor';
import { Button } from 'semantic-ui-react';
import {
  convertFromRaw,
  convertToRaw,
  DefaultDraftBlockRenderMap,
  EditorState,
} from 'draft-js';
// import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin';
import isSoftNewlineEvent from 'draft-js/lib/isSoftNewlineEvent';
import { includes } from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';

import addSVG from '@plone/volto/icons/circle-plus.svg';
import dragSVG from '@plone/volto/icons/drag.svg';

import deleteSVG from '@plone/volto/icons/delete.svg';

import { Icon } from '@plone/volto/components';

import config from '@plone/volto/registry';
// import { settings } from '~/config';
// import './Item.css';

const messages = defineMessages({
  placeholder: {
    id: 'Type the link label…',
    defaultMessage: 'Type the link label…',
  },
});

const labelBlockRenderMap = Map({
  unstyled: {
    element: 'p',
  },
});

const blockStyle = 'label';
const extendedLabelBlockRenderMap = DefaultDraftBlockRenderMap.merge(
  labelBlockRenderMap,
);

/**
 * Edit text cell class.
 * @class Cell
 * @extends Component
 */
class Item extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    index: PropTypes.number.isRequired,
    onSelectList: PropTypes.func.isRequired,
    // row: PropTypes.number,
    // cell: PropTypes.number,
    value: PropTypes.object,
    selected: PropTypes.bool,
    onChangeList: PropTypes.func.isRequired,
    onInsertItem: PropTypes.func.isRequired,
    onDeleteItem: PropTypes.func.isRequired,
    isWholeBlockSelected: PropTypes.bool,
    // isTableBlockSelected: PropTypes.bool,
    // disableNewBlocks: PropTypes.bool,
  };

  /**
   * Default properties
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    detached: false,
  };

  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs Cell
   */
  constructor(props) {
    super(props);

    if (!__SERVER__) {
      let labelEditorState;
      let urlEditorState;
      labelEditorState = EditorState.createWithContent(
        convertFromRaw(props.value.label),
      );
      urlEditorState = EditorState.createWithContent(
        convertFromRaw(props.value.url),
      );

      // const inlineToolbarPlugin = createInlineToolbarPlugin({
      //   structure: settings.richTextEditorInlineToolbarButtons,
      // });

      this.state = {
        labelEditorState,
        urlEditorState,
        // inlineToolbarPlugin,
      };
    }

    this.onChangeLabel = this.onChangeLabel.bind(this);
    this.onChangeUrl = this.onChangeUrl.bind(this);
  }

  /**
   * Component did mount lifecycle method
   * @method componentDidMount
   * @returns {undefined}
   */
  componentDidMount() {
    // if (this.node) {
    //   const onFocus = this.node.editor._onFocus;
    //   this.node.editor._onFocus = (event) => {
    //     onFocus(event);
    // this.props.onSelectCell(this.props.index, this.props.formId);
    // this.props.onSelectList(this.props.index, 'header');
    // this.props.onSelectList(this.props.index);
    // };
    // }
  }

  /**
   * Component will receive props
   * @method componentWillReceiveProps
   * @param {Object} nextProps Next properties
   * @returns {undefined}
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.isWholeBlockSelected !== this.props.isWholeBlockSelected &&
      this.props.index === 0
    ) {
      this.node.focus();
    }
  }

  /**
   * Change handler
   * @method onChange
   * @param {object} editorState Editor state.
   * @returns {undefined}
   */
  onChangeLabel(labelEditorState) {
    // this.setState({ labelEditorState }, () => {
    //   // this.props.onChange(this.props.row, this.props.cell, editorState);
    //   this.props.onChangeList(this.props.index, 'label', labelEditorState);
    // });
    convertToRaw(labelEditorState.getCurrentContent());
    this.setState({ labelEditorState }, () => {
      this.props.onChangeList(this.props.index, 'label', labelEditorState);
    });
  }
  onChangeUrl(urlEditorState) {
    convertToRaw(urlEditorState.getCurrentContent());
    this.setState({ urlEditorState }, () => {
      this.props.onChangeList(this.props.index, 'url', urlEditorState);
    });
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    if (__SERVER__) {
      return <div />;
    }

    // const { InlineToolbar } = this.state.inlineToolbarPlugin;
    // console.log(this.props.selected, this.props.index);
    const isActive = this.props.selected === this.props.index;
    return (
      <div
        className="Item"
        onClick={() => {
          this.props.onSelectList(this.props.index);
        }}
      >
        {/* {isActive ? (
          <div
            style={{
              visibility:
                this.state.selected === block &&
                !this.hideHandler(blocksDict[block])
                  ? 'visible'
                  : 'hidden',
              display: 'inline-block',
            }}
            {...provided.dragHandleProps}
            className="drag handle wrapper"
          >
            {...this.props.provided.dragHandleProps}

            <Icon name={dragSVG} size="18px" />
          </div>
        ) : null} */}
        <div className="item label">
          <Editor
            className="label"
            onChange={this.onChangeLabel}
            placeholder="Type the label text…"
            editorState={this.state.labelEditorState}
            // plugins={[
            //   this.state.inlineToolbarPlugin,
            //   ...settings.richTextEditorPlugins,
            // ]}
            blockRenderMap={config.settings.extendedBlockRenderMap}
            blockStyleFn={config.settings.blockStyleFn}
            customStyleMap={config.settings.customStyleMap}
            // handleReturn={(e) => {
            //   if (isSoftNewlineEvent(e)) {
            //     this.onChange(
            //       RichUtils.insertSoftNewline(this.state.labelEditorState),
            //     );
            //     return 'handled';
            //   }
            //   if (!this.props.detached && !this.props.disableNewBlocks) {
            //     const selectionState = this.state.headerEditorState.getSelection();
            //     const anchorKey = selectionState.getAnchorKey();
            //     const currentContent = this.state.headerEditorState.getCurrentContent();
            //     const currentContentBlock = currentContent.getBlockForKey(
            //       anchorKey,
            //     );
            //     const blockType = currentContentBlock.getType();
            //     if (!includes(settings.listBlockTypes, blockType)) {
            //       this.props.onSelectBlock(
            //         this.props.onAddBlock(
            //           settings.defaultBlockType,
            //           this.props.index + 1,
            //         ),
            //       );
            //       return 'handled';
            //     }
            //     return 'un-handled';
            //   }
            //   return {};
            // }}
            ref={(node) => {
              this.node = node;
            }}
          />
        </div>
        {/* <InlineToolbar /> */}
        <div className="item url">
          <Editor
            onChange={this.onChangeUrl}
            placeholder="Type the URL…"
            editorState={this.state.urlEditorState}
            // plugins={[
            //   this.state.inlineToolbarPlugin,
            //   ...settings.richTextEditorPlugins,
            // ]}
            blockRenderMap={config.settings.extendedBlockRenderMap}
            blockStyleFn={config.settings.blockStyleFn}
            customStyleMap={config.settings.customStyleMap}
            // handleReturn={(e) => {
            //   if (isSoftNewlineEvent(e)) {
            //     this.onChange(
            //       RichUtils.insertSoftNewline(this.state.textEditorState),
            //     );
            //     return 'handled';
            //   }
            //   if (!this.props.detached && !this.props.disableNewBlocks) {
            //     const selectionState = this.state.textEditorState.getSelection();
            //     const anchorKey = selectionState.getAnchorKey();
            //     const currentContent = this.state.textEditorState.getCurrentContent();
            //     const currentContentBlock = currentContent.getBlockForKey(
            //       anchorKey,
            //     );
            //     const blockType = currentContentBlock.getType();
            //     if (!includes(settings.listBlockTypes, blockType)) {
            //       this.props.onSelectBlock(
            //         this.props.onAddBlock(
            //           settings.defaultBlockType,
            //           this.props.index + 1,
            //         ),
            //       );
            //       return 'handled';
            //     }
            //     return 'un-handled';
            //   }
            //   return {};
            // }}
          />
        </div>
        {isActive ? (
          <>
            <Button
              basic
              icon
              onClick={() => this.props.onInsertItem()}
              className="block-add-button"
            >
              <Icon name={addSVG} className="block-add-button" size="24px" />
            </Button>
            <Button
              basic
              icon
              onClick={() => this.props.onDeleteItem()}
              className="block-clear-button"
            >
              <Icon
                name={deleteSVG}
                className="block-clear-button"
                size="18px"
              />
            </Button>
          </>
        ) : null}
      </div>
    );
  }
}

export default Item;
